import type { ReactNode } from 'react'
import Lock from 'lucide-react/dist/esm/icons/lock'
import Mail from 'lucide-react/dist/esm/icons/mail'
import ShieldCheck from 'lucide-react/dist/esm/icons/shield-check'

export const SUPPORT_EMAIL = 'support@mezzapay.com'

export const elevatedCardClassName =
  'gap-0 rounded-3xl border border-border/40 bg-white py-0 shadow-none shadow-[0_8px_30px_-4px_rgba(0,0,0,0.12)]'

export const elevatedPanelClassName =
  'rounded-2xl border border-border/60 bg-white p-5 text-center shadow-none shadow-[0_6px_24px_-4px_rgba(0,0,0,0.1)]'

export function PortalStatusPageShell({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-page px-6 py-12">
      <div className="w-full max-w-md space-y-5">{children}</div>
    </div>
  )
}

export function PortalStatusWordmark() {
  return (
    <img
      src="/mezza_wordmark.png"
      alt="Mezza"
      className="mx-auto h-5 w-auto"
      width={101}
      height={18}
    />
  )
}

export function PortalOfficialBadge() {
  return (
    <div className="inline-flex items-center gap-2 rounded-full border border-border/50 bg-white px-3.5 py-1.5 text-xs font-semibold text-foreground">
      <ShieldCheck className="h-4 w-4 text-success" aria-hidden="true" />
      Official Mezza portal
    </div>
  )
}

export function PortalTrustFooter() {
  return (
    <div className={elevatedPanelClassName}>
      <div className="flex items-center justify-center gap-2.5">
        <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-success-bg/60">
          <Lock className="h-5 w-5 text-success-border" aria-hidden="true" />
        </span>
        <span className="text-sm font-semibold text-foreground">Encrypted connection</span>
      </div>
      <p className="mt-3 text-xs leading-relaxed text-muted-foreground">
        Secure Mezza portal, for help email{' '}
        <a
          href={`mailto:${SUPPORT_EMAIL}`}
          className="font-medium text-foreground underline-offset-2 hover:underline"
        >
          {SUPPORT_EMAIL}
        </a>
      </p>
    </div>
  )
}

export function PortalErrorHelpFooter() {
  return (
    <div className={elevatedPanelClassName}>
      <div className="flex items-center justify-center gap-2">
        <Mail className="h-4 w-4 shrink-0 text-muted-foreground" aria-hidden="true" />
        <p className="text-sm font-semibold text-foreground">Still stuck?</p>
      </div>
      <p className="mt-2 text-xs leading-relaxed text-muted-foreground">
        Describe what you were doing when this happened
      </p>
      <a
        href={`mailto:${SUPPORT_EMAIL}`}
        className="mt-1 inline-block text-xs font-medium text-foreground underline-offset-2 hover:underline"
      >
        {SUPPORT_EMAIL}
      </a>
    </div>
  )
}
